export default __webpack_public_path__ + "static/media/nvda-token.1b9ba154.png";